import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { getCreateChat } from '@/api/index'

export const useStatusStore = defineStore('status', () => {
    // 定义需要监听的状态（例如：开关状态）
    const isActive = ref(false)
    // 存储当前会话ID
    const currentSessionId = ref('')

    // 修改状态的方法
    const toggleStatus = () => {
        isActive.value = !isActive.value
    }

    // 新增的获取会话ID的接口请求方法
    const fetchSessionId = async () => {
        try {
            // 这里替换成你实际的获取会话ID的接口地址，示例用了一个模拟接口
            const response = await getCreateChat()
            currentSessionId.value = response.id; // 保存会话ID到state中

        } catch (error) {
            console.error('获取会话ID接口请求出错：', error);
            throw error; // 抛出错误，让调用处可以捕获处理
        }
    }

    return { isActive, toggleStatus, currentSessionId,fetchSessionId }
})